export const POPUP_TITLE = {
    [ADD_TASK]: 'Add Task',
    [ADD_CLIENT]: 'Add Client',
    [ADD_NOTE]: 'Add Note',
    [UPLOAD_FILES]: 'Upload File',
};

export const ADD_TASK = 'Add Task';
export const ADD_CLIENT = 'Invite Member user';
export const ADD_NOTE = 'Add Note';
export const UPLOAD_FILES = 'Upload Files';